skrilla.controller('campaignDetailsCtrl', function ($scope,
                                                    $stateParams,
                                                    searchService,
                                                    currencyService,
                                                    modalService,
                                                    promotionService,
                                                    cacheService,
                                                    srefService,
                                                    profileTagService,
                                                    constantsService,
                                                    racingEventService,
                                                    adminV2Service,
                                                    queryService) {
    $scope.validate = {}
    $scope.selected = 0;
    $scope.key = "campaignDetails";
    $scope.tabs = [
        {title: "Users"},
        {title: "Betting Markets"},
        {title: "Betting Events"},
        {title: "Promotions"},
        {title: "Logs"}
    ];

    $scope.resetUsersQuery = function () {
        return {
            campaignId: $stateParams.id,
            id: "",
            username: "",
            email: "",
            firstName: "",
            lastName: "",
            phone: "",
            verificationStatus: null,
            state: "",
            country: null,
            signupIp: "",
            limit: 20,
            marketingCategories: constantsService.getMarketingCategoriesForQuery(),
            statuses: {
                ACTIVE: false,
                LOCKED: false,
                CLOSED: false
            },
            tags: profileTagService.getTagsForCheckboxes()
        };
    };


    $scope.update = function(){
        cacheService.registerObject("campaign", $scope.campaign)
        //Clashing modals, let the modal do a get before it closes
        cacheService.registerObject("getCampaign", getCampaign)
        modalService.openModal("views/campaignDetails/updateCampaignModal.html", true, 'lg', true, true, function(){
            getCampaign()
        });
    }
    $scope.promoModal = function(){
        cacheService.registerObject("campaignId", $stateParams.id)
        //Clashing modals, let the modal do a get before it closes
        cacheService.registerObject("getCampaign", getCampaign)
        modalService.openModal("views/campaignDetails/applyPromoToCampaignModal.html", true, 'lg', true, true);
    }
    $scope.marketModal = function(){
        cacheService.registerObject("campaignId", $stateParams.id)
        //Clashing modals, let the modal do a get before it closes
        cacheService.registerObject("getCampaign", getCampaign)
        modalService.openModal("views/campaignDetails/applyMarketToCampaignModal.html", true, 'lg', true, true);
    }
    $scope.eventModal = function(){
        cacheService.registerObject("campaignId", $stateParams.id)
        //Clashing modals, let the modal do a get before it closes
        cacheService.registerObject("getCampaign", getCampaign)
        modalService.openModal("views/campaignDetails/applyEventToCampaignModal.html", true, 'lg', true, true);
    }
    $scope.userModal = function(){
        cacheService.registerObject("campaignId", $stateParams.id)
        //Clashing modals, let the modal do a get before it closes
        cacheService.registerObject("getCampaign", getCampaign)
        modalService.openModal("views/campaignDetails/applyUserToCampaignModal.html", true, 'lg', true, true);
    }

    $scope.complete = function(){
        modalService.confirm("Are you sure you'd like to complete this campaign?", function(){
            searchService.put("campaigns/" + $stateParams.id + "/complete", {}, "Successfully completed", true).then(function(response){
                getCampaign()
            })
        })
    }
    $scope.publish = function(){
        modalService.confirm("Are you sure you'd like to publish this campaign?", function(){
            searchService.put("campaigns/" + $stateParams.id + "/publish", {}, "Successfully published", true).then(function(response){
                getCampaign()
            })
        })
    }

    function generateEventName(a){
        if (racingEventService.isRacingEvent(a.eventType)) {
            return `R${a.attributes.raceNumber} @ ${a.attributes.venueName} - ${a.eventName}`
        } else {
            return a.eventName;
        }
    }

    function getCampaign(){
        searchService.get("campaigns/" + $stateParams.id, "", false).then(function(response){
            $scope.campaign = response.data;
            //$scope.usersTableData.data = $scope.campaign.associations.USER
            $scope.promosTableData.data = $scope.campaign.associations.PROMOTION_CODE
            $scope.marketsTableData.data = $scope.campaign.associations.BETTING_MARKET?.map((a)=> {
                a.eventName = generateEventName(a.event);
                return a
            })
            $scope.eventsTableData.data = $scope.campaign.associations.BETTING_MARKET_EVENT?.map((a)=> {
                a.name = generateEventName(a);
                return a
            })
        })
    }
    getCampaign()


    $scope.usersTableData = {
        columns: [
            {title: "Username", field: "username"},
            {title: "Full Name", field: "fullName"},
            {title: "Phone", field: "phone"},
            {title: "Email", field: "email"},
            {title: "Verification Status", field: "verificationStatus"},
            {title: "Status", field: "status"},
            {title: "Currency", field: "fiatCurrency"},
            {title: "Created At", field: "createdAt", filter:{name: 'dateTimeFormatter'}},
            {title: '[X]', buttonText: 'X', isButton: true, buttonStyle: 'warn', onClick: removeAssociation},
        ],
        rows: {orderBy: "-createdAt", onClick: clickUser, style: "cursor: pointer;"},
        isSkrillaTable: true,
        data: $scope.users
    }

    $scope.promosTableData = {
        columns: [
            {title: "Code", field: "code"},
            {title: "Name", field: "definitionName"},
            {title: "Purpose", field: "purpose"},
            {title: "Active", field: "active"},
            {title: '[X]', buttonText: 'X', isButton: true, buttonStyle: 'warn', onClick: removeAssociation},
        ],
        rows: {orderBy: "-createdAt", onClick: clickPromotion, style: "cursor: pointer;"},
        isSkrillaTable: true,
    }

    $scope.marketsTableData = {
        columns: [
            {title: "Name", field: "name"},
            {title: "Event", field: "eventName"},
            {title: "Market Type", field: "marketType.name"},
            {title: "Promotional", field: "promotional"},
            {title: "Status", field: "status"},
            {title: "Next Bet Stop", field: "nextBetStop", filter:{name: 'dateTimeFormatter'}},
            {title: '[X]', buttonText: 'X', isButton: true, buttonStyle: 'warn', onClick: removeAssociation},
        ],
        rows: {orderBy: "-createdAt", onClick: clickMarket, style: "cursor: pointer;"},
        isSkrillaTable: true,
    }
    $scope.eventsTableData = {
        columns: [
            {title: "Name", field: "name" },
            {title: "Event Type", field: "eventType"},
            {title: "Sport", field: "sport"},
            {title: "Scheduled Start Time", field: "scheduledStartTime", filter:{name: 'dateTimeFormatter'}},
            {title: '[X]', buttonText: 'X', isButton: true, buttonStyle: 'warn', onClick: removeAssociation},
        ],
        rows: {orderBy: "-createdAt", onClick: clickEvent, style: "cursor: pointer;"},
        isSkrillaTable: true,
    }

    function removeAssociation(association){
        modalService.confirm("Are you sure you'd like to remove this association?", function(){
            //Users are actual users not associations
            let isUser = association.associationType === undefined;
            let query = {};
            let property = isUser ? "entityId" : "id";
            query[property] = association.id
            searchService.deleteRequest("campaigns/" + $stateParams.id + "/associations/1" + queryService.getQueryString(query, $scope.key), "Successfully removed association!", true).then(function(){
                getCampaign()
                $scope.usersTableData.data = $scope.usersTableData.data.filter((a)=> {return a.id !== association.id});
                $scope.$apply();
            })
        })
    }

    function clickUser(user, event){
        srefService.go("userDetails", {id: user.id}, event)
    }

    function clickMarket(market, event){
        srefService.go("bettingMarketDetails", {id: market.id}, event)
    }
    function clickEvent(bettingEvent, event){
        if (racingEventService.isRacingEvent(bettingEvent.eventType)) {
            adminV2Service.openV2(`/racing/races/${bettingEvent.eventId}`)
        } else {
            srefService.go("bettingMarkets", {eventId: bettingEvent.eventId}, event)
        }
    }

    function clickPromotion(promo, event){
        srefService.go("promotionCodeAndClaims", {id: promo.id}, event)
    }

});
